import React from "react";

const SearchIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="15"
			height="15"
			viewBox="0 0 15 15"
			fill="none"
			{...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.6667 6.91669C10.6667 8.84969 9.09969 10.4167 7.16669 10.4167C5.23368 10.4167 3.66667 8.84969 3.66667 6.91669C3.66667 4.98368 5.23368 3.41667 7.16669 3.41667C9.09969 3.41667 10.6667 4.98368 10.6667 6.91669ZM10.0283 10.6033C9.2381 11.2176 8.24511 11.5834 7.16669 11.5834C4.58935 11.5834 2.5 9.49403 2.5 6.91669C2.5 4.33935 4.58935 2.25 7.16669 2.25C9.74403 2.25 11.8334 4.33935 11.8334 6.91669C11.8334 7.9951 11.4676 8.98808 10.8533 9.77832L12.7992 11.7242C13.027 11.952 13.027 12.3214 12.7992 12.5492C12.5714 12.777 12.2021 12.777 11.9743 12.5492L10.0283 10.6033Z"
				fill="#D9DBE9"
			/>
		</svg>
	);
};

export default SearchIcon;
